import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Services from "../components/homi/Services";
import Features from "../components/homi/Features";
import ContactCta from "../components/homi/ContactCta";

export default function ServicesPage() {
  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <PageBanner title="Our Services" crumb="Services" subtitle="Expert trades for every part of your home — all under one roof." />
        <Services />
        <Features />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
